<div class="wrapper scrollable-container">
<div class="container">
 
<channels-header (onSearch)="onSearch($event)" (onCancelSearch)="onCancelSearch()" [searchBar]="true"></channels-header>

		<div style="margin-bottom:15px;" *ngIf="searchText"><h5>Пошук: "{{searchText}}"</h5></div>

		<div *ngIf="!loading; else loader">	
		 	<div  class="searchBlock" *ngIf="searchText && channels?.length"><h6>Канали</h6></div>	
		<div *ngIf="channels" class="row channel-wrapper">


 
		<!-- let channel of channels -->
		<div *ngFor="let channel of channels" class="col col-sm-12 col-md-6 col-lg-4 col-lg-4 col-xl-3 col-item" >
			<div [routerLink]="['/channel', channel.url ]"  class="channel-item">

				<div  [style.background]="channel.thumb_image ? 'url('+channel.thumb_image+')' : ''" class="thumb">

				 <div class="live-label3" *ngIf="channel.hasLive">
					<div class="lbl live">LIVE</div>
					</div>
				</div> 
				<div class="bottom">

				<div  [style.background]="channel.avatar_image ? 'url('+channel.avatar_image+')' : ''" class="avatar"></div>
				
					<div class="title"> 
						<div class="text">{{channel.title}}</div>
						<div *ngIf="channel.views" class="views"><nb-icon  style="color: #929292;font-size: 18px;" [icon]="'eye-outline'" pack="eva"></nb-icon> <span>{{channel.views | numberSpaced}}</span></div>
					</div>

				</div>

			</div>
		</div>
		</div>


		

					<div  class="streams" *ngIf="searchStreams">
 	<div  class="searchBlock" *ngIf="searchText && searchStreams?.length"><h6>Трансляції</h6></div>
						

<div class="stream-item" [routerLink]="['/watch']"  [queryParams]="{v: stream.publicIdentity}"    *ngFor="let stream of searchStreams">
							<div [style.background]="stream.coverImage ? 'url('+stream.thumbImage+')' : ''" class="stream-cover"></div>
							<div class="stream-title">{{stream.title}}</div>
							
						</div>
 		</div>


					<div  class="streams" *ngIf="searchVideos">
 	<div  class="searchBlock" *ngIf="searchText && searchVideos?.length"><h6>Відео</h6></div>
						

<div class="stream-item" [routerLink]="['/watch']"  [queryParams]="{v: video.publicIdentity}"    *ngFor="let video of searchVideos">
							<div [style.background]="video.coverImage ? 'url('+video.thumbImage+')' : ''" class="stream-cover"></div>
							<div class="stream-title">{{video.title}}</div>
							
						</div>
 		</div>




		<div *ngIf="channels?.length === 0"> 
			 <p *ngIf="searchText && !searchStreams?.length  && !searchVideos?.length ">Результатів не знайдено</p> 
			 <p *ngIf="!searchText">Каналів поки немає</p> 
		</div>

 
		</div>
		   <ng-template #loader>
        <div class="row">
		<div class="col">
		<div style="display:flex;  width:100%; height:300px; "> 
			<div style="display:flex;margin: auto;"> <app-loader></app-loader></div>
		    
		 </div>
		 </div>
        </div>
    </ng-template> 

	 
</div>

	 
</div>
